import { render, staticRenderFns } from "./m-info-block.vue?vue&type=template&id=67d5eebb&scoped=true&lang=pug&"
import script from "./m-info-block.vue?vue&type=script&lang=js&"
export * from "./m-info-block.vue?vue&type=script&lang=js&"
import style0 from "./m-info-block.vue?vue&type=style&index=0&id=67d5eebb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5eebb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
